const performanceName = (name) => `autoclever:${name}`;

const canMeasure = () => (
  typeof window !== 'undefined' &&
  typeof window.performance?.mark === 'function'
);

export const markStartup = (name) => {
  if (!canMeasure()) return;
  window.performance.mark(performanceName(name));
};

export const measureStartup = (name, startMark, endMark) => {
  if (!canMeasure() || typeof window.performance?.measure !== 'function') return;
  try {
    window.performance.measure(
      performanceName(name),
      performanceName(startMark),
      performanceName(endMark)
    );
  } catch (_error) {
    // Optional diagnostic marks must never affect application startup.
  }
};

